import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
import style from "../../styles/form.module.css";

// import { useDispatch, useSelector } from "react-redux";
// import { AddPorcentaje, UpdatePorcentaje } from "../../actions/porcentaje";
// import { AccessCtrl } from '../../../actions/index'

// Acciones
import { Estado } from "../../actions/Estado";
import { GetUsuarios } from "../../actions/usuario";
import { GetServicios } from "../../actions/servicio";

export function validate(input) {
   let errors = {};
   if (input.id === "") {
      errors.id = "Debe indicar Id!";
   }

   if (input.descripcion === "") {
      errors.descripcion = "Debe Ingresar una Descripcion";
   }
   if (input.usr_serv === "") {
      errors.usr_serv = "Debe Ingresar un Precio";
   }
   if (input.serv_id === "") {
      errors.serv_id = "Debe Ingresar un Servicio";
   }
   return errors;
}

function ABMPorcentaje() {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "porcentaje";
   var urlPor = url;
   var metodo = "PUT";

   var btnGrabar = true;

   const estados = Estado();
   const usuarios = GetUsuarios();
   const servicios = GetServicios();

   const location = useLocation();
   const { state } = location;

   const navigate = useNavigate();
   const [input, setInput] = useState({
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      usr_id: state ? state.usr_id : 0,
      usr_serv: state ? state.usr_serv : 0,
      serv_id: state ? state.serv_id : 0,
      porcentaje: state ? state.porcentaje : 0,
      cod_status: state ? state.cod_status : "1",
   });

   const [errors, setErrors] = useState({});

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
      setErrors(
         validate({
            ...input,
            [e.target.name]: e.target.value,
         })
      );
   }

   // function handleStatus(e) {
   //    e.preventDefault();
   //    setInput({
   //       ...input,
   //       cod_status: e.target.value,
   //    });
   //    setErrors(
   //       validate({
   //          ...input,
   //          [e.target.name]: e.target.value,
   //       })
   //    );
   // }

   const handleSubmit = (e) => {
      e.preventDefault();
      urlPor = url + `/${input.id}`;
      console.log("input: ", input);
      if (input.usr_serv === ""){
         input.usr_serv ="0"
      }
      if (input.id === 0) {
         urlPor = url;
         metodo = "POST";
      }
      mutate(input);
      // window.location.href = "/porcentaje";
   };

   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(urlPor, {
            method: metodo,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/Porcentaje";
      },
      onError: () => {
         alert("Error");
      },
   });
   
   if (estados) {
      if (estados.length > 0 && estados.companyId === 0) {
         input.companyId = estados[0].companyId;
      }
   }
   
   console.log("input: ", input, servicios);
   console.log('usuarios: ', usuarios);

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">
                     Datos del Porcentaje : {input.name}
                  </h1>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Porcentaje id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : // <div className={style.input_group}>
                     //    <span class="input-group-text" id="basic-addon1">
                     //       ID:
                     //    </span>
                     //    <input
                     //       type="text"
                     //       id="id"
                     //       name="id"
                     //       value={input.id}
                     //       onChange={handleChange}
                     //       className={style.input_field}
                     //    />
                     // </div>
                     null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Servicio:</span>
                     <select
                        name="serv_id"
                        id="serv_id"
                        onChange={(e) => handleChange(e)}
                        value={input.serv_id}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {servicios &&
                           servicios.map((serv) => {
                              return (
                                 <option
                                    selected
                                    value={serv.id_primary}
                                    key={serv.id}
                                 >{`${serv.descripcion}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Usuario:</span>
                     <select
                        name="usr_id"
                        id="usr_id"
                        onChange={(e) => handleChange(e)}
                        value={input.usr_id}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {usuarios &&
                           usuarios.map((usr) => {
                              if (parseInt(usr.estadousuario.id) === 1) {
                              return (
                                 <option
                                    selected
                                    value={usr.id}
                                    key={usr.id}
                                 >{`${usr.nombrecompleto}`}</option>
                              );
                              } else {
                                 return null;
                              }
                           })}{" "}
                     </select>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Profesional:
                     </span>
                     <select
                        name="usr_serv"
                        id="usr_serv"
                        onChange={(e) => handleChange(e)}
                        value={input.usr_serv}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {usuarios &&
                           usuarios?.map((dat) => {
                              console.log('dat',dat,dat.perfilusuarios.length);
                              for (let ii = 0;ii < dat.perfilusuarios.length;ii++) {
                                 // console.log('dat.perfilusuarios[ii].id: ',dat.username,dat.perfilusuarios[ii],ii);
                                 if (parseInt(dat.perfilusuarios[ii].id) === 2) {
                                    return (
                                       <option
                                          selected
                                          value={dat.id}
                                          key={dat.id}
                                       >
                                          {dat.nombrecompleto}
                                       </option>
                                    );
                                 } 
                              }
                           })}{" "}
                     </select>
                  </div>

                  {/* <div className="d-flex p-1"> */}
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Porcentaje:</span>
                     <input
                        type="number"
                        id="porcentaje"
                        name="porcentaje"
                        value={input.porcentaje}
                        onChange={handleChange}
                        className={style.input_field}
                     />
                  </div>

                  {/* </div> */}

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((tabla) => {
                              if (tabla.id === 1 && tabla.cod !== 0) {
                                 return (
                                    <option
                                       selected
                                       value={tabla.id}
                                       key={tabla.id}
                                    >{`${tabla.nombre}`}</option>
                                 );
                              } else {
                                 return null;
                              }
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           GRABAR
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/porcentaje");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMPorcentaje;
